"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { MenuIcon } from "../../icons/index.js";
import makeStyles from "../../theming/make-styles.js";
import { renderNodeOrComponent } from "../utils/render-node-or-component.js";
const useStyles = makeStyles()((theme, { color, sticky }, classes) => {
    const palette = theme.palette(color).header;
    return {
        divider: {
            [theme.breakpoints.up("md")]: {
                borderRight: `${theme.size(1)} solid ${palette.divider.borderColor}`,
            },
        },
        header: Object.assign(Object.assign({}, (sticky && {
            position: "sticky",
            top: 0,
            zIndex: 1,
        })), { display: "grid", gridTemplateColumns: `
        [header-start header-left-start] minmax(min-content, max-content)
        [header-left-end] ${theme.spacing("xl")} [header-main-start] 1fr
        [header-main-end header-right-start] minmax(min-content, max-content) [header-right-end header-end] ${theme.spacing("xl")}`, gridRow: "header-start / header-end", alignItems: "center", justifyItems: "flex-start", width: "100%", minHeight: theme.size(56), backgroundColor: palette.header.backgroundColor, boxShadow: theme.shadow("sm") }),
        left: {
            display: "inline-flex",
            alignSelf: "stretch",
        },
        logo: {
            "display": "inline-flex",
            "alignItems": "center",
            "padding": theme.spacing(0, "xl"),
            "& img": {
                maxHeight: theme.size(56),
            },
        },
        middle: {
            gridColumn: "header-main-start / header-main-end",
        },
        right: {
            gridColumn: "header-right-start / header-right-end",
            [`.${classes.middle} + &`]: {
                paddingLeft: theme.spacing("xl"),
            },
        },
        toggle: {
            "display": "inline-flex",
            "alignItems": "center",
            "justifyContent": "center",
            "height": "100%",
            "minWidth": theme.size(53),
            "backgroundColor": palette.toggle.backgroundColor,
            "border": 0,
            "cursor": "pointer",
            "svg": {
                color: palette.toggle.color,
            },
            [`&.${classes.divider}`]: {
                borderRight: `${theme.size(1)} solid ${palette.divider.borderColor}`,
            },
            "&:hover svg": {
                color: palette.toggle.hover.color,
            },
            "&:focus": {
                outline: 0,
            },
            "&:active svg": {
                color: palette.toggle.active.color,
            },
        },
    };
});
export const DefaultToggle = React.forwardRef(function DefaultToggle(_a, ref) {
    var { className, color = "primary" } = _a, props = __rest(_a, ["className", "color"]);
    const { classes, cx } = useStyles({ color });
    return (_jsx("button", Object.assign({ ref: ref, className: cx(classes.toggle, className) }, props, { children: _jsx(MenuIcon, { strokeWidth: 2.5 }) })));
});
export const Header = React.forwardRef(function Header(_a, ref) {
    var { children, className, color = "primary", logo, sticky = false, toggleButton = DefaultToggle, onToggle } = _a, props = __rest(_a, ["children", "className", "color", "logo", "sticky", "toggleButton", "onToggle"]);
    const [middle, right] = React.Children.toArray(children);
    const { classes, cx } = useStyles({ color, sticky });
    return (_jsxs("div", Object.assign({ ref: ref, className: cx(classes.header, className), "data-component": "header" }, props, { children: [_jsxs("div", { className: cx(classes.left, { [classes.divider]: !!logo }), children: [renderNodeOrComponent(toggleButton, { className: classes.divider, color, onClick: onToggle }), logo && _jsx("div", { className: classes.logo, children: logo })] }), middle && right && _jsx("div", { className: classes.middle, children: middle }), _jsx("div", { className: classes.right, children: right || middle })] })));
});
export default Header;
//# sourceMappingURL=header.js.map